/**
 * Payment statuses as serialized by the backend (NextPayment.paymentStatus, BillPlan.status, etc.).
 * Centralized here to avoid duplicated hardcoded strings across the frontend and to keep any
 * future tweak to the domain in a single place.
 *
 * Mirrors the enum defined in the backend at api/src/models/BillPlan.ts. Keep both sides in sync
 * whenever the payments domain changes.
 */

const PROCESSING_PAYMENT_STATUSES_TUPLE = ['procesando', 'verificando-por-fina'] as const;
const PAID_PAYMENT_STATUSES_TUPLE = ['pagado'] as const;

export type ProcessingPaymentStatus = (typeof PROCESSING_PAYMENT_STATUSES_TUPLE)[number];
export type PaidPaymentStatus = (typeof PAID_PAYMENT_STATUSES_TUPLE)[number];

export const PROCESSING_PAYMENT_STATUSES: ReadonlyArray<string> = PROCESSING_PAYMENT_STATUSES_TUPLE;

export const PAID_PAYMENT_STATUSES: ReadonlyArray<string> = PAID_PAYMENT_STATUSES_TUPLE;
